import { makeStyles } from "@material-ui/core/styles";
import HighlightOff from "../../../assets/images/highlight_off_black_24dp.svg";
import gameMuiTheme from "../../layout/styles/GameMuiTheme";

const playListStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
		height: "calc(100% - 30px)"
	},
	search: {
		[theme.breakpoints.down("md")]: {
			maxWidth: "calc(100% - 45px)"
		},
		marginBottom: 10,
		"& label.Mui-focused": {
			color: theme.palette.gameMode.primary
		},
		"& .MuiInput-underline:after": {
			borderBottomColor: theme.palette.gameMode.primary
		},
		"& .MuiOutlinedInput-root": {
			"& fieldset": {
				borderColor: theme.palette.gameMode.primary
			},
			"&:hover fieldset": {
				borderColor: theme.palette.gameMode.primary
			},
			"&.Mui-focused fieldset": {
				borderColor: theme.palette.gameMode.primary
			}
		}
	},
	searchField: {
		caretColor: theme.palette.common.white,
		color: theme.palette.gameMode.primary,
		"& input": {
			color: theme.palette.common.white,
			"&::-webkit-search-cancel-button": {
				"-webkit-appearance": "none",
				height: "1.5em",
				width: "1.5em",
				backgroundColor: "transparent",
				borderRadius: "50em",
				background: `url(${HighlightOff})`,
				"background-size": "contain",
				"pointer-events": "none",
				filter: "invert(100%)",
				cursor: "pointer"
			},
			"&:focus::-webkit-search-cancel-button": {
				"pointer-events": "all"
			}
		}
	},
	noPlays: {
		color: theme.palette.gameMode.primary
	},
	actionMenu: {
		padding: "0 !important",
		background: theme.palette.common.white
	},
	insertPlayHeader: {
		display: "flex",
		justifyContent: "center",
		padding: "0 0 10px 0",
		"& button": {
			zIndex: 1
		}
	},
	flippedIcon: {
		"& .MuiSvgIcon-root": { transform: "scale(1, -1)" }
	},
	accordion: {
		width: "100%",
		backgroundColor: "transparent",
		border: "1px solid #fff",
		boxShadow: "none",
		"&:not(:last-child)": {
			borderBottom: 0
		},
		"&:before": {
			display: "none"
		},
		"&$expanded": {
			margin: 0
		}
	},
	accordionSummary: {
		minHeight: 64,
		backgroundColor: gameMuiTheme.palette.menu.backgroundColor,
		borderBottom: "1px solid #fff !important",
		marginBottom: -1,
		"&$expanded": {
			borderBottom: "1px solid #fff !important"
		},
		"& .MuiAccordionSummary-expandIcon": {
			color: theme.palette.common.white
		},
		"&$expanded .MuiAccordionSummary-expandIcon": {
			color: theme.palette.common.white
		}
	},
	accordionSummaryContent: {
		// minHeight: 64,
		"&$expanded": {
			margin: 0
		}
	},
	expanded: {}
}));

export default playListStyles;
